import {
    Button,
    DialogProps,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export type ErrorModalProps = DialogProps & {
    hideClose?: boolean;
    title?: string;
    onTryAgain?: (event: React.MouseEvent<unknown>) => void;
};

const ErrorModal = (props: ErrorModalProps) => {
    const { children, hideClose, title, onTryAgain, onClose, ...other } = props;

    const { t } = useTranslation('error_modal');

    const handleClose = () => {
        onClose?.({}, 'backdropClick');
    };

    return (
        <Dialog onClose={handleClose} {...other}>
            <DialogTitle>{title || t('oops')}</DialogTitle>

            <DialogContent>
                <DialogContentText>{children}</DialogContentText>

                {onTryAgain && <DialogContentText>{t('please-try-again')}</DialogContentText>}
            </DialogContent>

            <DialogActions>
                {!hideClose && (
                    <Button variant="outlined" onClick={handleClose}>
                        {t('Close')}
                    </Button>
                )}

                {onTryAgain && (
                    <Button color="primary" variant="contained" onClick={onTryAgain}>
                        {t('try-again')}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ErrorModal;
